import {GET_CASE_USERS} from "../constants/Constants";

export const totalCasesReducer = (
  state = { totalCoins: {} },
  action
) => {
  switch (action.type) {
    case GET_CASE_USERS:
      return { ...state, totalCases:action.payload };
    default:
      return state;
  }
};
